<script>
const KNOWN_REASONS = [
  'customer_not_found',
  'outlet_service_or_staff_not_linked',
  'no_room_available',
  'cancelled_in_aoikumo_cannot_reopen',
  'aoikumo_error',
];

export default {
  name: 'AoikumoSyncBadge',
  props: {
    customMetadata: {
      type: Object,
      default: null,
    },
  },
  computed: {
    sync() {
      return this.customMetadata?.aoikumo_sync || null;
    },
    isSynced() {
      return this.sync?.status === 'synced';
    },
    reasonKey() {
      const { reason } = this.sync || {};
      return KNOWN_REASONS.includes(reason) ? reason : 'unknown';
    },
    reasonText() {
      return this.$t(`AOIKUMO_SYNC.REASONS.${this.reasonKey}`);
    },
  },
};
</script>

<template>
  <div v-if="sync" data-testid="aoikumo-sync-badge" class="text-xs">
    <span
      v-if="isSynced"
      data-testid="aoikumo-sync-synced"
      class="inline-flex items-center gap-1 px-2 py-0.5 font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
    >
      {{ $t('AOIKUMO_SYNC.SYNCED', { ref: sync.booking_ref }) }}
    </span>
    <div
      v-else
      data-testid="aoikumo-sync-not-synced"
      class="p-2 rounded-md bg-yellow-50 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-200"
    >
      <p class="mb-0 font-medium">
        {{ $t('AOIKUMO_SYNC.NOT_SYNCED') }}
      </p>
      <p class="mb-0" data-testid="aoikumo-sync-reason">
        {{ reasonText }}
      </p>
      <p
        v-if="sync.reason === 'aoikumo_error' && sync.detail"
        class="mb-0 break-words opacity-80"
        data-testid="aoikumo-sync-detail"
      >
        {{ sync.detail }}
      </p>
    </div>
  </div>
</template>
